/**
 * @file   src\pages\LoadingSkeleton.js
 * @brief  This file is responsible for loader.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";

const LoadingSkeleton = (props) => {
  return (
    <>
      <div className="col-md-4">
        <div className="favorites-skeleton-wrapper">
          <div className="favorites-skeleton-right-wrap">
            <div className="skeleton-btn-small"></div>
            <div className="skeleton-btn-small"></div>
          </div>
          <div className="favorites-skeleton-img-wrap"></div>
          <div className="favorites-skeleton-info-wrap">
            <div className="favorites-skelton-info-top"></div>
            <div className="favorites-skelton-info-second"></div>
            <div className="favorites-skelton-info-third"></div>

            <div className="favorites-skelton-info-bottom"></div>
          </div>
        </div>
      </div>

      <div className="col-md-4">
        <div className="favorites-skeleton-wrapper">
          <div className="favorites-skeleton-right-wrap">
            <div className="skeleton-btn-small"></div>
            <div className="skeleton-btn-small"></div>
          </div>
          <div className="favorites-skeleton-img-wrap"></div>
          <div className="favorites-skeleton-info-wrap">
            <div className="favorites-skelton-info-top"></div>
            <div className="favorites-skelton-info-second"></div>
            <div className="favorites-skelton-info-third"></div>

            <div className="favorites-skelton-info-bottom"></div>
          </div>
        </div>
      </div>

      <div className="col-md-4">
        <div className="favorites-skeleton-wrapper">
          <div className="favorites-skeleton-right-wrap">
            <div className="skeleton-btn-small"></div>
            <div className="skeleton-btn-small"></div>
          </div>
          <div className="favorites-skeleton-img-wrap"></div>
          <div className="favorites-skeleton-info-wrap">
            <div className="favorites-skelton-info-top"></div>
            <div className="favorites-skelton-info-second"></div>
            <div className="favorites-skelton-info-third"></div>

            <div className="favorites-skelton-info-bottom"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoadingSkeleton;
